<div class="dropdown text-left">
  <button type="button" class="btn btn-primary rounded bg-brand bg-green-hover text-nowrap py-1 pl-3 mx-0 pr-2"
    data-toggle="dropdown" (click)="changeArrowDirection()">
    <div class="pl-1 iconWidth d-inline-block">
      <i class="icon20 se-icon-body_eye float-right"></i>
    </div>
    <div class="font-weight-bolder pl-1 pb-1 font-size-xs d-inline-block align-text-bottom">
      <span>
        <ng-container i18n="@@app.view_dropdown">VIEW</ng-container>
      </span>
    </div>
    <div class="pl-1 iconWidth d-inline-block">
      <i class="icon18 se-icon float-right m-0">{{isOpenedViewSelect ? 'arrow2_up' : 'arrow2_down'}}</i>
    </div>
  </button>
  <div class="dropdown-menu fix-dropdown-position  dropdown-menu-width">
    <a class="dropdown-item cursor-pointer" (click)="togglePrice()">
      <div class="tick-width d-inline-block">
        @if (displayPrice) {
          <i class="icon18 se-icon-notification_ok position-initial"></i>
        }
      </div>
      <ng-container i18n="@@app.view_dropdown_price">Price</ng-container>
    </a>
  </div>
</div>
